module.exports = __webpack_public_path__ + "static/media/Доклад на директора за връзки с инвеститорите.dcabe22a.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2021/Доклад на директора за връзки с инвеститорите.pdf
// module id = 103
// module chunks = 0